/**
 * SPDX-FileCopyrightText: 2020-2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import { getCancelableClient } from "./client.js";
import { onCsrfTokenError } from "./interceptors/csrf-token.js";
import { onMaintenanceModeError } from "./interceptors/maintenance-mode.js";
import { onNotLoggedInError } from "./interceptors/not-logged-in.js";
const cancelableClient = getCancelableClient();
cancelableClient.interceptors.response.use((r) => r, onCsrfTokenError(cancelableClient));
cancelableClient.interceptors.response.use((r) => r, onMaintenanceModeError(cancelableClient));
cancelableClient.interceptors.response.use((r) => r, onNotLoggedInError);
export { isAxiosError, isCancel } from 'axios';
export default cancelableClient;
